import { motion } from "framer-motion";

const links = [
  { label: "About", href: "#about", testid: "nav-about-link" },
  { label: "Pillars", href: "#pillars", testid: "nav-pillars-link" },
  { label: "Donate", href: "#donate", testid: "nav-donate-link" },
];

export default function Header() {
  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-jordan-ink/10 bg-jordan-sand/85 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-5 py-3 sm:px-10">
        <a href="#top" data-testid="header-logo-link" className="flex items-center gap-3">
          <img
            src="/assets/logo.png"
            alt="The Jordanian Hub — Almadafah emblem"
            data-testid="header-logo"
            className="h-12 w-auto sm:h-14"
          />
          <span className="hidden flex-col leading-none sm:flex">
            <span className="font-display text-sm font-800 font-extrabold uppercase tracking-[0.18em]">
              Jordanian Hub
            </span>
            <span className="font-arabic text-sm text-jordan-mute">المضافة · Almadafah</span>
          </span>
        </a>
        <nav className="flex items-center gap-6 sm:gap-9" data-testid="main-nav">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="link-underline hidden font-display text-xs font-bold uppercase tracking-[0.22em] text-jordan-ink md:block"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#donate"
            data-testid="header-donate-btn"
            className="border border-jordan-ink bg-jordan-ink px-5 py-2.5 font-display text-xs font-bold uppercase tracking-[0.22em] text-jordan-sand transition-colors duration-300 hover:border-jordan-red hover:bg-jordan-red"
          >
            Donate
          </a>
        </nav>
      </div>
    </motion.header>
  );
}
